import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  getItemOfSessionStorage,
  isContainAlphabet
} from "../../services/common/utils";
import { useNavigate } from "react-router-dom";
import { SELECTED_LANG } from "../../services/common/Constants";

const DeleteConfirmationModal = ({
  show,
  toggleModal,
  title = '',
  data,
  buttontext
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const language = getItemOfSessionStorage(SELECTED_LANG);
  
  // close_icon + heading + message
    return (
      <Modal
        show={show}
        backdrop="true"
        className="modal bottom_modal animated slideInUp faster popup2 country-accro-comp1 p-0 sprint16-modal-popup sp16-modal-bounce-effect"
        onHide={toggleModal}
      >
        <Modal.Header className="border-0">
          <h6 className="dir-ltrl">{title}</h6>

          <button className="badges-close-button" 
            onClick={toggleModal}
          >
            <img
              src={process.env.PUBLIC_URL + "/assets/images/cross_dark.svg"}
              alt=""
              title=""
            />
          </button>
        </Modal.Header>
        <Modal.Body>
   
          <div className="text-center modal-body">
          {data?.filter(item => item?.meta_key === "delete_info_icon") &&
            <div className="modal_img mb-4">
              <img src={ language === "en" ? 
                          data?.filter(item => item?.meta_key === "delete_info_icon")[0]?.meta_value_english: 
                          data?.filter(item => item?.meta_key === "delete_info_icon")[0]?.meta_value_arabic
                        } 
                    width="60" 
                    alt="" 
                    title=""
              />
            </div>
          }
        <div className="sprint16-delete-acc-popup">
        
        {data?.filter(item => item?.meta_key === "delete_info_title") &&
        <h6>{ language === "en" ? 
              data?.filter(item => item?.meta_key === "delete_info_title")[0]?.meta_value_english: 
              data?.filter(item => item?.meta_key === "delete_info_title")[0]?.meta_value_arabic}</h6>
        }

        {data?.filter(item => item?.meta_key === "delete_info_message") &&
          <p>{ language === "en" ? 
            data?.filter(item => item?.meta_key === "delete_info_message")[0]?.meta_value_english: 
            data?.filter(item => item?.meta_key === "delete_info_message")[0]?.meta_value_arabic}
          </p>
        }

        <div class="flex_grp_align_center mt-4">
                <button class="custom_btn custom_btn_primary_outline btn_block me-2 sp16_custom_btn" onClick={toggleModal}>
                {t("no_close")}
                </button>
                <button class="custom_btn custom_btn_primary btn_block ms-2 sp16_custom_btn" onClick ={()=>navigate('/delete-account', {state: {data: data, buttontext: buttontext}, buttontext: "kdsfjc"})}>
                {t("delete")}
                </button>
        </div>

        </div>
        </div>
        </Modal.Body>
      </Modal>
    );

};
export default DeleteConfirmationModal;
